<template>
  <el-dialog
    title="待审核入群申请"
    :visible.sync="visible"
    width="640px"
    @open="loadPendingList"
  >
    <div v-loading="loading" class="join-audit-dialog">
      <div v-if="pendingList.length === 0" class="empty-tip">暂无待审核申请</div>
      <div v-else class="audit-list">
        <div class="audit-item" v-for="item in pendingList" :key="item.id">
          <head-image
            :size="44"
            :url="item.sendHeadImage"
            :name="item.sendNickName || `用户${item.sendId || ''}`"
          />
          <div class="audit-main">
            <div class="name-row">
              <span class="name">{{ item.sendNickName ||  "未知用户" }}</span>
              <span class="uid" @click="handleCopyId(item.sendId)">ID: {{ item.sendId || "-" }}</span>
            </div>
            <div class="reason">
              {{ item.remark || '申请加入群聊'}}
            </div>
            <div class="reason">
              申请时间：{{ moment(item.inviteTime).format('YYYY-MM-DD HH:mm:ss') }}
            </div>
          </div>
          <div class="actions">
            <el-button
              size="mini"
              type="success"
              :loading="auditLoadingId === item.id && auditLoadingApproved === true"
              @click="onAudit(item, true)"
            >
              通过
            </el-button>
            <el-button
              size="mini"
              type="danger"
              plain
              :loading="auditLoadingId === item.id && auditLoadingApproved === false"
              @click="onAudit(item, false)"
            >
              拒绝
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { handleCopy } from "@/utils/common";
import moment from "moment";
import HeadImage from "../common/HeadImage.vue";

export default {
  name: "GroupJoinAuditDialog",
  components: {
    HeadImage,
  },
  props: {
    groupId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      pendingList: [],
      auditLoadingId: null,
      auditLoadingApproved: null,
      moment,
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    handleCopyId(id) {
      if (!id) {
        return;
      }
      handleCopy(id);
      this.$message.success("ID已复制");
    },
    loadPendingList() {
      if (!this.groupId) {
        this.pendingList = [];
        return;
      }
      this.pendingList = this.$store.state.groupStore.joinRequests.filter(item => item.groupId == this.groupId);
    },
    onAudit(item, approved) {
      if (!item || !item.id) {
        return;
      }
      this.auditLoadingId = item.id;
      this.auditLoadingApproved = approved;
      this.$http({
        url: "/group/join/audit",
        method: "post",
        data: {
          id: item.id,
          approved: !!approved,
        },
      })
        .then(() => {
          this.$message.success(approved ? "已通过申请" : "已拒绝申请");
          this.pendingList = this.pendingList.filter((v) => v.id !== item.id);
          this.$store.commit("removeJoinRequest", item);
          this.$emit("updated");
        })
        .finally(() => {
          this.auditLoadingId = null;
          this.auditLoadingApproved = null;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.join-audit-dialog {
  min-height: 120px;
}

.empty-tip {
  text-align: center;
  color: #909399;
  padding: 32px 0;
}

.audit-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.audit-item {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 10px;
}

.audit-main {
  flex: 1;
  min-width: 0;
}

.name-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.name {
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}

.uid {
  color: #909399;
  font-size: 14px;
  cursor: pointer;
}

.reason {
  margin-top: 4px;
  color: #606266;
  font-size: 13px;
  line-height: 1.5;
  word-break: break-all;
  text-align: left;
}

.actions {
  white-space: nowrap;
}
</style>
